/**
 * Order line types, mirroring Legacy\Orders\EpmsOrderLineInfo. Note that TOTAL
 * sits between DELIVERY and VAT - reading tax off type 4 gives the order total.
 */
export const ORDER_LINE_TYPE_PRODUCT = 0;
export const ORDER_LINE_TYPE_ADDED_COST = 1;
export const ORDER_LINE_TYPE_DISCOUNT = 2;
export const ORDER_LINE_TYPE_DELIVERY = 3;
export const ORDER_LINE_TYPE_TOTAL = 4;
export const ORDER_LINE_TYPE_VAT = 5;
